import { ModalSlideout } from '@juvare/common-web-ui/ModalSlideout';
import { ParticipantDetailsComponentProps } from '@juvare/missions/ui/providers';
import React from 'react';
import { RmsAccountDetailsComponent } from '../../accounts';

export const ParticipantDetailsComponent = ({
    participantId,
    onParticipantIdReset,
    slideoutMenuItems,
}: ParticipantDetailsComponentProps) => {
    if (!onParticipantIdReset) {
        return null;
    }
    return (
        <ModalSlideout open={!!participantId} onClose={onParticipantIdReset} data-test='participant-details-slideout'>
            {participantId && (
                <RmsAccountDetailsComponent
                    accountId={participantId}
                    slideoutMenuItems={slideoutMenuItems}
                    onClose={onParticipantIdReset}
                />
            )}
        </ModalSlideout>
    );
};
